import { SuperbatchResourceRecorder } from '../src/SuperbatchResourceRecorder.ts';

export const superbatchCSSRecorder = new SuperbatchResourceRecorder(false);
export const superbatchJSRecorder = new SuperbatchResourceRecorder(true);
